module.exports = __webpack_public_path__ + "static/media/DSC_0065.ed039df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0065.jpg
// module id = 626
// module chunks = 0